import React from 'react';
import ReactDOM from 'react-dom';
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import userReducer from './reduxFeature/user';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter,BrowserRouter } from 'react-router-dom';


const store = configureStore({
  reducer: {
    user: userReducer,
  }
})

ReactDOM.render(
  <React.StrictMode>
    <HashRouter >
      <Provider store={store}>
        <App />
      </Provider>
    </HashRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
